import { render, staticRenderFns } from "./PersonsList.vue?vue&type=template&id=2cf60a0f"
import script from "./PersonsList.vue?vue&type=script&lang=js"
export * from "./PersonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports